import { useFormatDateRange } from '@insio/ui-toolkit';
import { plainDateFrom } from '@insio/dates';

/** Formats a reported period in the user's locale; falls back to the raw ISO values. */
export function useFormatReportPeriod(): (from: string, to: string) => string {
  const formatDateRange = useFormatDateRange();

  return (from, to) => {
    try {
      return formatDateRange(plainDateFrom(from.slice(0, 10)), plainDateFrom(to.slice(0, 10)));
    } catch {
      return `${from} – ${to}`;
    }
  };
}
